import { ref } from 'vue'

import {
  EventSettingsRecord,
  EventSettingsRecordUpdate,
  EventSettingsTable,
} from '@desktop/utils/database'
import { createSharedComposable } from '@vueuse/core'

import { useEventId } from './useEventId'

export const useEventSettings = createSharedComposable(() => {
  const eventId = useEventId()

  // TODO: move to Sport initialization
  // Soccer.vue: {eventSettings: {shotsCoordinates: true}}
  // Basketball.vue: {eventSettings: {assignPlayerOnPitch: true}}
  const eventSettings = ref<EventSettingsRecord>({
    eventId: eventId.value,
    shotsCoordinates: true,
    assignPlayerOnPitch: true,
  })

  const loaded = EventSettingsTable.get(eventId.value).then((stored) => {
    eventSettings.value = {
      ...eventSettings.value,
      ...stored,
    }
  })

  const updateEventSettings = (value: EventSettingsRecordUpdate) => {
    eventSettings.value = Object.assign(eventSettings.value, value)

    return EventSettingsTable.upsert(eventId.value, value)
  }

  return {
    eventSettings,
    updateEventSettings,
    loaded,
  }
})
